export default __webpack_public_path__ + "static/media/switch-logo-white-small.09690bc2.png";